import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './calculator-steps-wrapper.scss';

/**
 * Renders basic calculator steps wrapper.
 * @param {string} className
 * @param {node|node[]} children
 * @returns {ReactElement}
 */
export function CalculatorStepsWrapper({ className = '', children, noPadding = false }) {
  return (
    <section className={classNames('calculator-steps-wrapper', { 'p-1': !noPadding }, className)}>{children}</section>
  );
}

CalculatorStepsWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  noPadding: PropTypes.bool,
};
